
enum IdCardType {
  IDENTIFIED_CARD = 'IDENTIFIED_CARD',
  CITIZEN_IDENTIFIED_CARD = 'CITIZEN_IDENTIFIED_CARD'
}

enum ProductCardType {
  CREDIT = 'CREDIT',
  PREPAID = 'PREPAID'
}

enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

enum CustomerReferenceType {
  HUSBAND_WIFE = 'HUSBAND_WIFE',
  SIBLING = 'SIBLING',
  FRIEND = 'FRIEND',
  PARENT = 'PARENT',
  CHILD = 'CHILD'
}

export { IdCardType, ProductCardType, Gender, CustomerReferenceType }